import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {FOODITWEBSITE} from '../../constants/constant';

import {FooterDot, FooterStyled, FooditLogo, FooterPoweredBy} from './Footer.style';

export class Footer extends PureComponent {
  render() {
    const {name, expand, extraIndent, navUrls} = this.props;
    return (
      <FooterStyled
        expand={expand}
        extraIndent={extraIndent}
        data-rw="footer--component"
      >
        <span data-rw="footer--copyright">&copy; {name}</span>
        <FooterDot />
        <Link
          to={navUrls.menuUrl}
          data-rw="footer--view-menu-link"
        >
          <FormattedMessage id="footer.viewMenu" />
        </Link>
        <FooterDot />
        <Link
          to={navUrls.termsUrl}
          data-rw="footer--terms-link"
          target="_blank"
        >
          <FormattedMessage id="footer.termsAndConditions" />
        </Link>
        <FooterPoweredBy data-rw="footer--poweredby">
          <a
            href={FOODITWEBSITE.URL}
            data-rw="footer--terms-link"
            target="_blank"
          >
            <FormattedMessage id="footer.poweredBy" />
            <FooditLogo
              src="https://cdn-dot-foodit-prod.appspot.com/assets/foodit--logo.svg"
              alt="FOODit"
            />
          </a>
        </FooterPoweredBy>
      </FooterStyled>
    );
  }
}

Footer.propTypes = {
  name: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  expand: PropTypes.bool.isRequired,
  extraIndent: PropTypes.bool.isRequired,
  navUrls: PropTypes.object
};

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/Footer.js